// Shared dark Material-React-Table styling, mirroring the look of the
// Registrations admin page so MRT surfaces don't clash with the dark
// admin chrome.

export const darkPaperSx = {
  backgroundColor: "rgba(30, 41, 59, 0.5)",
  backgroundImage: "none",
  color: "#e2e8f0",
  border: "1px solid rgba(148,163,184,0.16)",
  borderRadius: "1rem",
  boxShadow: "none",
};

export const darkToolbarSx = {
  backgroundColor: "transparent",
  color: "#e2e8f0",
  borderBottom: "1px solid rgba(148,163,184,0.08)",
  "& .MuiButtonBase-root": { color: "#cbd5e1" },
  "& .MuiInputBase-root": { color: "#e2e8f0" },
  "& .MuiInput-underline:before": { borderBottomColor: "rgba(148,163,184,0.2)" },
  "& .MuiSvgIcon-root": { color: "#94a3b8" },
};

export const darkHeadCellSx = {
  padding: "10px 8px",
  backgroundColor: "rgba(15, 23, 42, 0.6)",
  color: "#cbd5e1",
  borderBottom: "1px solid rgba(148,163,184,0.16)",
  fontWeight: 600,
  fontSize: "0.7rem",
  letterSpacing: "0.04em",
  textTransform: "uppercase" as const,
  "& .MuiBox-root": { color: "#cbd5e1" },
  "& .MuiSvgIcon-root": { color: "#94a3b8" },
};

export const darkBodyCellSx = {
  padding: "8px 8px",
  color: "#e2e8f0",
  fontSize: "0.8rem",
  borderBottom: "1px solid rgba(148,163,184,0.08)",
};

export const darkRowSx = {
  backgroundColor: "transparent",
  "&:hover td": { backgroundColor: "rgba(148,163,184,0.06) !important" },
};

export const darkSearchSx = {
  "& .MuiInputBase-input": { color: "#e2e8f0" },
  "& .MuiInputBase-input::placeholder": { color: "#64748b", opacity: 1 },
};
